import { graphql } from "gatsby";
import styles from "./daily-schedule-block.module.less";
import { DailySchedule, ScheduleList, SimplifyGatsbyQuery, convertLabelsToMap } from "@parksandresorts/core";

type DailyScheduleBlockProps = {
  scheduleList: Array<ScheduleList>;
};

const DailyScheduleBlock = ({
  labelsOverride,
  ...props
}: SimplifyGatsbyQuery<Queries.DailyScheduleBlockFragment> & DailyScheduleBlockProps) => {
  return (
    <div className={styles.dailyScheduleWrapper}>
      <DailySchedule {...props} labelsOverride={convertLabelsToMap(labelsOverride)} />
    </div>
  );
};

export default DailyScheduleBlock;

export const fragmentDailyScheduleBlock = graphql`
  fragment DailyScheduleBlock on ContentfulDailyScheduleBlock {
    contentful_id
    id
    scheduleList {
      contentful_id
      title
      scheduleType
      listedByTags {
        title
      }
      isExpanded
      groupAdmissionList {
        ...GroupAdmissionBlock
      }
    }
    showConcertsInCalendar
    promotionBannerText {
      raw
    }
    promotionBannerLink {
      ...Link
    }
    labelsOverride {
      list {
        key
        value
      }
    }
  }
`;
